import(/* webpackMode: "eager" */ "/app/src/app/tools/quick-statistics/page.tsx");
